enum Errors {
  ErrInvalidEmailContent = 'invalid_email_content',
  ErrInvalidEmailDomain = 'invalid_email_domain',
  ErrGeneral = 'general_error',
}

export { Errors };
